// extracted by mini-css-extract-plugin
module.exports = {"blockImage":"style-module__blockImage___RKOg6","openBlockIcon":"style-module__openBlockIcon___K-G-y","block":"style-module__block___Il92b"};